const initialState = () => ({
  active: [],
  details: undefined,
  filters: {
    status: [
      {
        display: "すべて",
        statuses: [1, 2, 3, 4, 5, 6]
      },
      {
        display: "完了",
        statuses: [3, 5, 6]
      },
      {
        display: "トライ",
        statuses: [2]
      },
      {
        display: "がんばろう",
        statuses: [4]
      },
      {
        display: "もうすぐ",
        statuses: [1]
      }
    ]
  },
  historicalTotal: 0,
  list: [],
  loading: false
});

const assignmentState = initialState();

export { assignmentState };
